export const toggles = {
  call_to_action_enabled: false,
  toggle_requirements_refactor_enabled: true,
  toggle_redirect_new_widget_enabled: true,
  toggle_upgrade_document_detector_sdk_to_5_14_2_enabled: true,
};
